import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/appointment/list')({
    beforeLoad: () => { throw redirect({ to: '/appointment/scheduler' }) },
})
